
export function EmptyFilePreview({ isDragActive }: { isDragActive: boolean; }) {
    return (
        <div>
            {isDragActive ?
                <p className="text-gray-500">Drop the files here ...</p>
                :
                <p className="text-gray-500">Drag 'n' drop a files here, or click to select files</p>}

            <p className="text-gray-500">Max size: 50MB</p>
        </div>
    );
}
